var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVpn = function SvgVpn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278,
    height: 213
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82867"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h278v213H0z",
    "data-name": "Rectangle 30783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M34.967 152.706c-9.891-10.445.69-38.39 16.644-55.48 19.4-20.777 46.145-38.255 97.842-32.312 42.688 4.91 69.192 26.439 78.207 37.53 14.335 17.626 24.692 42.5 16.058 52.781-14.488 17.265-74.348-12.111-106.817-12.71s-79.848 33.477-101.934 10.191",
    "data-name": "Path 60127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff97c9",
    d: "M188.373 136.018H75.688l-23.7-77.478a4.943 4.943 0 0 1 4.737-6.393h102.328a4.945 4.945 0 0 1 4.73 3.5Z",
    "data-name": "Path 60128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M169.916 126.795h-80.84a4.995 4.995 0 0 1-4.775-3.531L66.354 64.589a2.488 2.488 0 0 1 2.382-3.218h80.839a4.99 4.99 0 0 1 4.775 3.531l17.948 58.675a2.488 2.488 0 0 1-2.382 3.218",
    "data-name": "Path 60129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f774b9",
    d: "M75.688 136.018h151.355a3.85 3.85 0 0 1 3.85 3.85v5.143a3.85 3.85 0 0 1-3.85 3.85h-147.5a3.85 3.85 0 0 1-3.85-3.85Z",
    "data-name": "Path 60130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M94.134 99.065a2.156 2.156 0 0 1-1.6-3.594l9.206-10.274a2.156 2.156 0 0 1 3.211 2.877l-9.206 10.274a2.15 2.15 0 0 1-1.611.717",
    "data-name": "Path 60131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M105.512 99.064a2.15 2.15 0 0 1-1.282-.424L90.367 88.366a2.156 2.156 0 0 1 2.567-3.464l13.863 10.279a2.156 2.156 0 0 1-1.285 3.887Z",
    "data-name": "Path 60132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M139.592 99.065a2.156 2.156 0 0 1-1.6-3.594l9.206-10.274a2.156 2.156 0 0 1 3.211 2.877l-9.206 10.274a2.15 2.15 0 0 1-1.611.717",
    "data-name": "Path 60133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M150.97 99.064a2.15 2.15 0 0 1-1.282-.424l-13.865-10.274a2.156 2.156 0 1 1 2.567-3.464l13.869 10.279a2.156 2.156 0 0 1-1.285 3.888Z",
    "data-name": "Path 60134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M131.383 105.558a2.15 2.15 0 0 1-1.026-.262c-6.221-3.377-12.415-.041-12.477-.007a2.156 2.156 0 1 1-2.081-3.775c.337-.186 8.344-4.5 16.615-.007a2.156 2.156 0 0 1-1.03 4.05Z",
    "data-name": "Path 60135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M195.65 91.276a3.66 3.66 0 0 1-3.568-2.883c-.679-3.058-1.109-5.394-.51-7.578.719-2.59 2.614-4.107 4.657-5.558a5.59 5.59 0 0 0 2.439-3.77 2.76 2.76 0 0 0-.964-2.306c-2.142-2.078-5.611 1.155-5.766 1.3 0 0-2.914 2.466-5.079-.12a4.03 4.03 0 0 1 0-5.149 16.8 16.8 0 0 1 4.75-3.1c4.167-1.774 8.137-1.109 11.179 1.83a10.1 10.1 0 0 1 3.167 8.123 12.75 12.75 0 0 1-5.5 9.183 7 7 0 0 0-1.843 1.552 17.4 17.4 0 0 0 .605 4.032 3.666 3.666 0 0 1-3.566 4.453Z",
    "data-name": "Path 60136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M197.412 103.966a4.242 4.242 0 1 0-4.242-4.242 4.24 4.24 0 0 0 4.242 4.242",
    "data-name": "Path 60137"
  }))));
};
export default SvgVpn;